import React from 'react'
import { type VariantProps } from 'class-variance-authority'
import { cn } from '../../../lib/utils'
import { badgeVariants } from '../../../utils/layoutVariants'

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  icon?: React.ReactNode
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, status, size, style, icon, children, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(badgeVariants({ status, size, style }), className)}
        {...props}
      >
        {icon && <span className="flex-shrink-0">{icon}</span>}
        {children}
      </span>
    )
  }
)
Badge.displayName = 'Badge'

export { Badge }
